import { SoftcatApiConfigPlatform, SoftcatApiWidget } from 'softcat:types/softcat-api.ts';

const extractPlatformVariants = ({ widget }: { widget?: SoftcatApiWidget }) => {
    return widget?.platformFilters?.flatMap((filter) => {
        return filter.platformVariants ?? [];
    });
};

const extractPropositions = ({ widget }: { widget?: SoftcatApiWidget }) => {
    return widget?.platformFilters?.flatMap((filter) => {
        return filter.propositions ?? [];
    });
};

const extractRegions = ({ widget }: { widget?: SoftcatApiWidget }) => {
    return widget?.platformFilters?.flatMap((filter) => {
        return filter.regions ?? [];
    });
};

const matchPlatforms = ({ platforms, widget }: { platforms: SoftcatApiConfigPlatform[]; widget?: SoftcatApiWidget }) => {
    const widgetPlatforms =
        widget?.platforms ??
        widget?.platformFilters?.flatMap((filter) => {
            return filter.platformIds ?? [];
        });

    return widgetPlatforms?.map((widgetPlatform) => {
        const platform = platforms.find((platform) => {
            return platform.code === widgetPlatform;
        });

        return platform?.badge || widgetPlatform;
    });
};

export const WidgetUtils = {
    extractPlatformVariants,
    extractPropositions,
    extractRegions,
    matchPlatforms,
};
